import { render, staticRenderFns } from "./DepositSettings.vue?vue&type=template&id=a164fde6&scoped=true"
import script from "./DepositSettings.vue?vue&type=script&lang=js"
export * from "./DepositSettings.vue?vue&type=script&lang=js"
import style0 from "./DepositSettings.vue?vue&type=style&index=0&id=a164fde6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a164fde6",
  null
  
)

export default component.exports